module.exports = __webpack_public_path__ + "static/roche-bg-4287a4cb1246549684ab829fc1b1671a.jpg";